/**
 * Display helpers for the Download Sessions panel.
 *
 * Since EN-1496 a passage download session lists only the passages that
 * download newly stored (Passage.CreatedDate inside the session's window,
 * apex-agm-v1). Re-downloading a range whose passages were all received
 * before (live, or by an earlier download) therefore completes with an empty
 * list. Without a message that looks like the download failed.
 */

export const NO_NEW_PASSAGES_MESSAGE =
  'No new passages: everything in this range was already stored.';

/** RFD FileType for a passage download (3 is raw data). */
export const PASSAGE_DOWNLOAD_FILE_TYPE = 0;

/** The parts of a download session the empty-state check needs. */
export interface DownloadSessionEmptyStateInput {
  downloadSessionId: number;
  fileType: number;
  state: string;
  passageCount: number;
  passages?: unknown[] | null;
  /** Session state when the passage list was last fetched, if ever. */
  passagesLoadedState?: string | null;
}

/**
 * True when a completed passage download has no new passages: the session is
 * real (not the pending placeholder), complete ('C'), a passage download, its
 * final count is 0, and the list fetched after it completed is empty. Requiring
 * a fetch made in state 'C' avoids flashing the message from a list that was
 * fetched (empty) while the download was still running.
 */
export function isCompletedWithNoNewPassages(
  session: DownloadSessionEmptyStateInput | null | undefined
): boolean {
  if (session == null) return false;
  return (
    session.downloadSessionId > 0 &&
    session.state === 'C' &&
    session.fileType === PASSAGE_DOWNLOAD_FILE_TYPE &&
    session.passageCount === 0 &&
    session.passagesLoadedState === 'C' &&
    (session.passages ?? []).length === 0
  );
}
